const getValueByPath = (value, path) => {
  return path.split(".").reduce((current, key) => current?.[key], value);
};

const toMessage = (value) => {
  if (Array.isArray(value)) {
    return value[0] ?? "";
  }

  if (typeof value === "string") {
    return value;
  }

  return "";
};

export const normalizeErrors = (value) => {
  if (!value) {
    return {};
  }

  if (typeof value === "string") {
    return {
      fallback_message: value,
    };
  }

  if (Array.isArray(value)) {
    return {
      fallback_message: value[0] ?? "",
    };
  }

  return value;
};

export const getFirstError = (errors, paths = []) => {
  for (const path of paths) {
    const message = toMessage(getValueByPath(errors, path));
    if (message) {
      return message;
    }
  }

  return "";
};
